import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import Select from '@jetbrains/ring-ui/components/select/select';
import { apiUserAuditTypeOptions } from '@api/users';
import ToolbarItem from '@app/common/toolbar-item/toolbar-item';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
export function EventsFilter({ value, onChange }) {
    const handleChange = useCallback((selected) => {
        onChange((selected === null || selected === void 0 ? void 0 : selected.key) ? selected.key : undefined);
    }, [onChange]);
    const serverConfig = useServerConfigContext();
    const idpImportEnabled = serverConfig.hasIdpIntegration();
    const eventOptions = apiUserAuditTypeOptions.filter(option => idpImportEnabled || (option.key !== 'ADDED_TO_GROUP' && option.key !== 'REMOVED_FROM_GROUP'));
    return (_jsx(ToolbarItem, { label: "Event type", children: _jsx(Select, { clear: true, label: "All", size: Select.Size.M, data: eventOptions, selected: apiUserAuditTypeOptions.find(option => option.key === value), onChange: handleChange, ...assignTestId('audit-logs-events-type-filter') }) }));
}
